import { Component } from '@angular/core';

@Component({
  selector: 'app-commission-plans',
  templateUrl: './commission-plans.component.html'
})
export class CommissionPlansComponent { }
